<template>
  <div class="row">
    <div class="flex md12" style="font-size: 15px, color: black">
      <a-spin size="large" :spinning="spinning" :indicator="indicator">
        <vxe-toolbar>
          <template #buttons>
            <vxe-input
              v-model="filterName_detable"
              type="search"
              placeholder="Input a key word"
              @keyup="searchEvent_detable"
            ></vxe-input>
            <vxe-button @click="exportDataEvent"
              ><a-icon type="cloud-download" /> Download</vxe-button
            >
          </template>
        </vxe-toolbar>
        <vxe-table
          border
          show-overflow
          :data="tableData_detable"
          :column-config="{ isHover: true }"
          :row-config="{ isCurrent: true, isHover: true, height: 40 }"
          row-id="id"
          size="small"
          ref="xTable"
          class="mytable"
          align="center"
          header-align="center"
        >
          <vxe-column field="dName" title="Drug name" width="150px" type="html">
            <template #default="{ row }">
              <a
                @click="goDrugDetails(row.CMapID, row.dName)"
                style="color: blue"
                >{{ row.dName }}</a
              >
            </template>
          </vxe-column>
          <vxe-column field="Alias" title="Aliases" type="html"></vxe-column>
          <vxe-column
            field="Description"
            title="Description"
            type="html"
          ></vxe-column>
          <vxe-column field="CMapID" title="cMAP ID" type="html"></vxe-column>
          <vxe-column
            field="MOA"
            title="Mechanisms of actions"
            type="html"
          ></vxe-column>
          <vxe-column
            field="CMapClass"
            title="cMAP Classes"
            type="html"
          ></vxe-column>
          <vxe-column
            field="ProteinTarget"
            title="Protein targets"
            type="html"
          ></vxe-column>
          <template #empty>
            <span style="color: grey"> No records found! </span>
          </template>
        </vxe-table>
        <vxe-pager
          background
          size="small"
          :loading="spinning"
          :current-page="tablePage_detable.currentPage"
          :page-size="tablePage_detable.pageSize"
          :total="tablePage_detable.totalResult"
          :page-sizes="[20, 50, 100]"
          :layouts="[
            'PrevPage',
            'JumpNumber',
            'NextPage',
            // 'FullJump',
            'Sizes',
            'Total',
          ]"
          @page-change="handlePageChange_table"
        >
        </vxe-pager>
      </a-spin>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  data() {
    return {
      // tableData: [],
      //加载
      spinning: true,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
      },
    };
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/drug/geneTarget_druglists.php"
      )
      .then((response) => {
        // this.tableData_detable = response.data;
        this.getdata_detable = response.data;
        this.findList_detable(this.getdata_detable);
        this.spinning = false;
      });
  },
  methods: {
    //页面跳转
    goDrugDetails(value, value2) {
      let routeData = this.$router.resolve({
        name: "drugModelResult",
        query: { drugid: value, dName: value2 },
      });
      window.open(routeData.href, "_blank");
    },
    findList_detable(data) {
      this.spinning = true;
      setTimeout(() => {
        const list = data;
        this.spinning = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    // 分页响应按钮
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    //全标查询
    searchEvent_detable() {
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = [
          "dName",
          "Alias",
          "CMapID",
          "MOA",
          "Description",
          "ProteinTarget",
        ];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
    // 导出底物蛋白列表
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "Compound_info_table",
          type: "txt",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        if (this.filterName_detable == "" || this.filterName_detable == " ") {
          const list = this.getdata_detable;
          this.$refs.xTable.exportData({
            filename: "Compound_info_table",
            type: "txt",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        } else {
          const list = this.tempdata_detable;
          this.$refs.xTable.exportData({
            filename: this.filterName_detable + "_related.Compound_info_table",
            type: "txt",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        }
      }
    },
  },
};
</script>
<style></style>
